import React from 'react'

function LoginHistory() {
  return (
    <div>LoginHistory</div>
  )
}

export default LoginHistory